import settingsModel, { Jurisdiction } from "slotworks/model/settings/settings-model";
import canvasManager, { Orientation } from "slotworks/graphics/canvas/canvas-manager";
import Point from "slotworks/utils/geom/point";
import Timer from "slotworks/utils/timer";
import deviceInfo from "slotworks/utils/device-info";
import wrapperMediator from "../../wrapper/wrapper-mediator";
import BaseRegulation from "slotworks/integration/revolver/regulations/base-regulation";

export default class SwedenTopBar extends BaseRegulation {

    public static RESIZE_DOWN_ON_PORTRAIT:boolean = true;

    public canvas: HTMLElement;
    public landscapeCanvasDOMContainer: HTMLElement;
    public portraitCanvasDOMContainer: HTMLElement;
    public footerDOMContainer: HTMLElement;
    public bar: HTMLElement;
    public betmenuElements: HTMLElement[];
    public linkElements: HTMLElement[];
    public mobileIntro: HTMLElement;

    public setup() {
        if(settingsModel.isJurisdiction(Jurisdiction.SE) && wrapperMediator.getBranding() !== 'relax' && document.getElementById("swedenTopBar")) {
            this.canvas = document.getElementsByTagName('canvas')[0];
            this.landscapeCanvasDOMContainer = document.querySelector("#landscape #canvasDOMContainer") as HTMLElement;
            this.portraitCanvasDOMContainer = document.querySelector("#portrait #canvasDOMContainer") as HTMLElement || 
                                                document.querySelector("#portraitv2 #canvasDOMContainer") as HTMLElement;
            this.footerDOMContainer = document.querySelector("#portrait #footerDOMContainer") as HTMLElement ||
                                        document.querySelector("#portraitv2 #footerDOMContainer") as HTMLElement;
            this.bar =  document.getElementById("swedenTopBar") as HTMLElement;
            this.betmenuElements = [
                document.getElementById('autoplay'),
                document.getElementById('bet'),
                document.getElementById('settings'),
                document.getElementById('paytable').getElementsByTagName('span')[0],
                document.getElementById('rules'),
                document.getElementById('history'),
                document.getElementById('betmenu')
            ];
            this.linkElements = [
                document.getElementById("spelpaus"),
                document.getElementById("spelser"),
                document.getElementById('stest')
            ];
            this.mobileIntro = document.querySelector("#Prompts #gameintro") as HTMLElement;
            
            let links = [
                "https://spela.svenskaspel.se/spelpaus",
                "https://spela.svenskaspel.se/logga-in?returnUrl=%2Fmin-profil%2Fgranser",
                "https://gamtest.se/v3/svenskaspel/sportcasino"
            ];

            this.linkElements.forEach((el,index) =>{
                el.onclick = ()=>{window.open(links[index],'_blank')};
            })
            
            const onOrientationChange = (orientation: number) => {
                if(orientation == Orientation.LANDSCAPE) {
                    this.onLandscape(25);
                }
                else {
                    this.onPortrait(35);
                }
            }
            canvasManager.onOrientationChange.add(onOrientationChange);
            onOrientationChange(canvasManager.orientation);
            
            let clock = document.getElementById("swedishRegulationClock") as HTMLElement; 
            if(clock) {
                let checkTime = (i: string) => {
                    if (Number(i) < 10) {i = "0" + i};
                    return i;
                };
                let tick = () => {
                    let today = new Date();
                    let h = today.getHours() + '';
                    let m = today.getMinutes() + '';
                    let s = today.getSeconds() + '';
                    m = checkTime(m);
                    s = checkTime(s);
                    clock.innerHTML = h + ":" + m + ":" + s;    
                };
                tick();
                Timer.setInterval(tick,100);
            }
        }
    }

    protected onPortrait(topBarHeight: number) {
        let background =  document.querySelector("#portrait #Background #default") as HTMLElement || 
                document.querySelector("#portraitv2 #Background #default") as HTMLElement;;
                
        const headers = document.querySelectorAll("#portrait #Header>div,#portraitv2 #Header>div");
        if(headers) {
            headers.forEach(el => {
                (el as HTMLElement).style.marginTop = topBarHeight + "px";
            });
        }
        this.portraitCanvasDOMContainer.style.marginTop = topBarHeight + "px";

        if(SwedenTopBar.RESIZE_DOWN_ON_PORTRAIT) {
            canvasManager.resizeRendererToOrientation(false, Math.floor(1.5 * topBarHeight ));
            canvasManager.resizeElement(this.canvas, 1,new Point(0.5),true, true);
        }

        this.canvas.style.marginTop = topBarHeight + "px";
        background.style.marginTop = topBarHeight + "px";
        this.footerDOMContainer.style.marginTop = this.toNumber(this.footerDOMContainer.style.marginTop) - topBarHeight + 'px';
        if(this.bar) {
            this.bar.style.margin = '0';
            this.bar.style.height = topBarHeight + "px";
            this.bar.style.width = this.portraitCanvasDOMContainer.style.width;
            this.bar.style.display = "flex";
        }
        this.betmenuElements.forEach(el => {
            el.style.width = "100%";
            el.style.height = window.innerHeight - topBarHeight + 'px';
            el.style.margin = '0';
            el.style.marginTop = topBarHeight + "px";
        })

        if(this.mobileIntro) {
            this.mobileIntro.style.width = "100%";
            this.mobileIntro.style.height = window.innerHeight - topBarHeight + 'px';
            this.mobileIntro.style.marginTop = topBarHeight + "px";    
        }
    }

    protected onLandscape(topBarHeight: number) {
        let height = this.toNumber(this.canvas.style.height);
        let margin = this.toNumber(this.canvas.style.marginTop) + topBarHeight + "px";
        canvasManager.resizeElement(this.canvas,(height - topBarHeight)/height,new Point(0.5),true);
        canvasManager.resizeElement(this.landscapeCanvasDOMContainer,(height - topBarHeight)/height,new Point(0.5),true);
        this.landscapeCanvasDOMContainer.style.marginTop = margin;
        this.canvas.style.marginTop = margin;
        
        if(this.bar) {
            this.bar.style.marginTop = this.toNumber(this.canvas.style.marginTop) - topBarHeight + "px";
            this.bar.style.marginLeft = this.canvas.style.marginLeft
            this.bar.style.height = topBarHeight + "px";
            this.bar.style.width = this.canvas.style.width;
            this.bar.style.display = "flex";
        }
        if(!deviceInfo.isDesktop){
            //scale betmenu elements one by one since their position is fixed with 100% width and height set for each one independently
            this.betmenuElements.forEach(el => {
                ['width','height','margin'].forEach((attribute:any) => {
                    el.style[attribute] = this.canvas.style[attribute];
                })
            })
        }
    } 

    protected toNumber = (str: string) => Number(str.split('px')[0]);
            
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/integration/revolver/regulations/sweden/responsible-gambling-links.ts